<script setup>
import { defineAsyncComponent, ref, watch } from 'vue';

import { useRoute } from 'vue-router';

import { useEbayListingDialog } from '@/composables/ebay/useEbayListingDialog.js';
import { useStickyBusinessProfileKey } from '@/composables/useStickyBusinessProfileKey.js';

const EbayListingDialog = defineAsyncComponent(() => import('./EbayListingDialog.vue'));
const { state, close } = useEbayListingDialog();
const route = useRoute();
const businessProfileKey = useStickyBusinessProfileKey();
const hasOpened = ref(false);

watch(() => state.open, (open) => {
  if (open) hasOpened.value = true;
}, { immediate: true });
watch(() => route.path, close);
watch(businessProfileKey, close);
</script>

<template>
  <EbayListingDialog
    v-if="hasOpened"
    v-model="state.open"
    :listing-id="state.listingId"
    :marketplace-id="state.marketplaceId"
    :business-profile-id="state.businessProfileId"
    :ebay-account-id="state.ebayAccountId"
  />
</template>
